import React from 'react'
import type {CategoryData} from '../data/types'

interface VendorLeaderboardProps {
  data: CategoryData
}

const VendorLeaderboard: React.FC<VendorLeaderboardProps> = ({data}) => {
  const filteredRows = data.leaderboard.rows.filter(
    ([, , small, mid, large]) => [small, mid, large].filter((v) => v && v !== 'n/a').length >= 2,
  )

  const cell = (v: string) => (!v || v === 'n/a' ? '—' : v)

  return (
    <section className="section light">
      <div className="wrap">
        <div className="subsection">
          <div className="sub-eyebrow">Top vendors</div>
          <h3>Who companies pay, and how much, per company size.</h3>
          <p className="sub-intro">{data.leaderboard.intro} Ordered by number of companies using the tool.</p>
          <div style={{overflowX: 'auto', WebkitOverflowScrolling: 'touch'}}>
            <table className="data-table leaderboard-table" style={{minWidth: 480}}>
              <thead>
                <tr>
                  <th>Vendor</th>
                  <th className="num">
                    Small<span className="size-meta">1–19 employees</span>
                  </th>
                  <th className="num">
                    Mid<span className="size-meta">20–99 employees</span>
                  </th>
                  <th className="num">
                    Large<span className="size-meta">100+ employees</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredRows.map(([color, name, small, mid, large]) => (
                  <tr key={name}>
                    <td className="strong">
                      <span className="brand-pill">
                        <span className="logo cat" style={{background: color}}>
                          {name.charAt(0)}
                        </span>
                        {name}
                      </span>
                    </td>
                    <td className="num">{cell(small)}</td>
                    <td className="num">{cell(mid)}</td>
                    <td className="num strong">{cell(large)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  )
}

export default VendorLeaderboard
